
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/sell", function() {
      var mod = require("private-next-pages/sell/index.ssr.js")
      if(module.hot) {
        module.hot.accept("private-next-pages/sell/index.ssr.js", function() {
          if(!next.router.components["/sell"]) return
          var updatedPage = require("private-next-pages/sell/index.ssr.js")
          next.router.update("/sell", updatedPage)
        })
      }
      return mod
    }]);
  